import React, { useState } from 'react';
import SearchSchools from '../../../Schools/components/searchSchools';
import ListItem from '../../../../components/ListItem';
import commonStyles from '../../DataDashboard.module.scss';
import styles from './SchoolSearch.module.scss';
import BackLink from '../../../../components/BackLink';
import schoolPNG from '../../../../images/school.png';

const SchoolSearch = () => {
    const [results, setResults] = useState([]);
    const [noResults, setNoResults] = useState(false);

    return (
        <>
            <BackLink to='/dataDashboard' text='Back' />
            <div className={commonStyles.dataDashboardHeader}>
                <h2 className='u-display-flex u-align-center' >
                    <span style={{marginRight: '1rem'}}>School Search</span>
                    <img
                        src={schoolPNG}
                        alt='school-image'
                        width='25'
                        height='22'
                    ></img>
                </h2>
            </div>

            <div className={styles.contentContainer}>
                <SearchSchools
                    setResults={setResults}
                    setNoResults={setNoResults}
                />

                {results.length ? (
                    <ul className='u-m-top-2'>
                        {results.map((school) => (
                            <ListItem
                                key={`school-${school.id}`}
                                linkPath={`/dataDashboard/schoolStats/${school.id}`}
                                mainText={
                                    <>
                                        {school.name}{' '}
                                        <span className='light body-text'>
                                            {school.schoolCode}
                                        </span>
                                    </>
                                }
                                subText={
                                    <>
                                        <b>{school.city}</b>{' '}
                                        <span className='light smaller-text'>
                                            {school.address} {school.address2}{' '}
                                            &ndash; {school.zip}
                                        </span>
                                    </>
                                }
                            />
                        ))}
                    </ul>
                ) : (
                    noResults && (
                        <p className='u-m-top-3'>
                            <b>No schools found</b>
                        </p>
                    )
                )}
            </div>
        </>
    );
};

export default SchoolSearch;
